import React from 'react';
import { TableRow, Text, TableHeader } from '@unimed-fesp/components';

import theme from '../../../styles/theme';

const TableHeaderBeneficiario = () => {
  return (
    <TableRow>
      <TableHeader minWidth={40} />
      <TableHeader minWidth={350}>
        <Text
          font="bold 16px/14px Calibri"
          color={theme.movGrey}
          text="Beneficiários"
        />
      </TableHeader>
      <TableHeader minWidth={150}>
        <Text font="bold 16px/14px Calibri" color={theme.movGrey} text="Grau" />
      </TableHeader>
      <TableHeader minWidth={120}>
        <Text
          font="bold 16px/14px Calibri"
          color={theme.movGrey}
          text="Modalidade"
        />
      </TableHeader>
      <TableHeader minWidth={150}>
        <Text
          font="bold 16px/14px Calibri"
          color={theme.movGrey}
          text="Proposta/Termo"
        />
      </TableHeader>
      <TableHeader minWidth={150}>
        <Text
          font="bold 16px/14px Calibri"
          color={theme.movGrey}
          text="Modalidade destino"
        />
      </TableHeader>
    </TableRow>
  );
};

export default TableHeaderBeneficiario;
